import Header from '../../../__Layout/Header';
import React , {useState} from "react";
import Loader from '../../../utils/Loader';
import Delete from "./Delete";
import Create from "./Create";
import Update from "./Update";
import { useGetAdminParticipantsQuery } from "../../../Services/api";
import {pageUrl,pageSize} from "../../../utils/constants/constants";
export default function Index() {
    const [page, setPage] = useState(0);
    const [search, setSearch] = useState("");
    const {
            data: getAdminParticipants,
            isLoading: isGetLoading,
        } = useGetAdminParticipantsQuery({ pageUrl, params: { search, page, pageSize } });
        
      const getPrevious= () => {
        setPage(page-1);
        setSearch("");
      }
      const getNext=()=>{
        setPage(page+1);
        setSearch("");
      }
      const findSearch=(e)=>{
        setPage(0);
        setSearch(e.target.value);
      }
      if(isGetLoading) return  <Loader></Loader>
      return (
        <div className="vehicleCategories">
            <Header />
            <main id="main" className="main">
            <div className="card">
                <div className="card-body">
                    <h5 className="card-title">Manage Batch</h5>
                    <ul className="nav nav-tabs nav-tabs-bordered d-flex" id="borderedTabJustified" role="tablist">
                       <li className="nav-item flex-fill" role="presentation">
                        <button className="nav-link w-100 active" id="home-tab" data-bs-toggle="tab" data-bs-target="#bordered-justified-home" type="button" role="tab" aria-controls="home" aria-selected="true">Batch List</button>
                        </li>
                        <li className="nav-item flex-fill" role="presentation">
                        <button className="nav-link w-100" id="profile-tab" data-bs-toggle="tab" data-bs-target="#bordered-justified-profile" type="button" role="tab" aria-controls="profile" aria-selected="false">Batch Add</button>
                        </li>
                    </ul>
                    <div className="tab-content pt-2" id="borderedTabJustifiedContent">
                        <div className="tab-pane fade show active" id="bordered-justified-home" role="tabpanel" aria-labelledby="home-tab"> 
                            <section className="section">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="card">
                                            <div className="card-body">
                                                <h5 className="card-title"></h5>
                                                <div className='row'>
                                                    <div className='col-lg-8'></div>
                                                    <div className='col-lg-4'>
                                                        <div className="datatable-search pull-right">
                                                            <input className="datatable-input" placeholder="Search..." type="search" title="Search within table" onChange={findSearch}/>
                                                        </div>
                                                    </div>
                                                </div>
                                                <table className="table">
                                                        <thead>
                                                            <tr>
                                                                <th>#</th>
                                                                <th className='text-capitalize'>First Name</th>
                                                                <th className='text-capitalize'>Last Name</th>
                                                                <th className='text-capitalize'>Email</th>
                                                                <th className='text-capitalize'>Role</th>
                                                                <th className='text-capitalize'>Course</th>
                                                                <th className='text-capitalize'>Group</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                        {
                                                            getAdminParticipants?.data?.data_array?.map((item,index) => {
                                                            return (
                                                                
                                                                <tr key={index}>
                                                                    <th scope="row">{index++}</th>
                                                                   
                                                                    <td>{item?.student?.first_name} </td>
                                                                    <td>{item?.student?.last_name} </td>
                                                                    <td>{item?.student?.email} </td>
                                                                    <td>{'Student'} </td>
                                                                    <td>{item?.course?.course_name} </td>
                                                                    <td>{item?.course_group?.title}</td>
                                                                    <td>{item.mobile_number}</td>
                                                                    <td>
                                                                    <div className="btn-group" role="group" aria-label="Button group with nested dropdown">
                                                                        <div className="btn-group" role="group">
                                                                            <button id="btnGroupDrop1" type="button" className="btn btn-secondary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                                                Action
                                                                            </button>
                                                                            <div className="dropdown-menu" aria-labelledby="btnGroupDrop1">
                                                                                <Delete id={item.enroll_id} />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    </td>                                                                    
                                                                </tr>                                            
                                                                )  
                                                            })  
                                                        } 
                                                        </tbody>
                                                </table>                        
                                                <nav aria-label="Page navigation example">
                                                    <ul className="pagination">
                                                    {getAdminParticipants?.data?.currentPage !==0 ? <li className="page-item"><button type="button" className="page-link" onClick={getPrevious}>Previous</button></li> :''}
                                                    <li className="page-item"> {getAdminParticipants?.data?.currentPage+1} </li>                                                  
                                                    <li className="page-item"> of {getAdminParticipants?.data?.totalPages}</li>
                                                    {getAdminParticipants?.data?.currentPage !==getAdminParticipants?.data?.totalPages ? <li className="page-item"><button type="button" className="page-link" onClick={getNext}>Next</button></li>:''}
                                                    </ul>
                                                </nav>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>  
                        </div>
                       
                        <Create />
                    </div>
                </div>
               
            </div>

            </main>
          
        </div>
    );
}
